(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('esterni', {
                parent: 'entity',
                url: '/esternis?page&sort&search',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI'],
                    pageTitle: 'uniromaLandingApp.esterni.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/esterni/esternis.html',
                        controller: 'EsterniController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'cognome,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                	pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('esterni');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('esterni.detail', {
                parent: 'entity',
                url: '/esterni/{id}?userId',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI', 'ROLE_GESTIONE_ESTERNI_RIDOTTI'],
                    pageTitle: 'uniromaLandingApp.esterni.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/esterni/esterni-detail.html',
                        controller: 'EsterniDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('esterni');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Esterni', function($stateParams, Esterni) {
                    	console.log("----------");
                    	console.log($stateParams);
                        return Esterni.get({id : $stateParams.id});
                    }],
                    userId: ['$stateParams', function($stateParams) {
                        return $stateParams.userId;
                    }]
                }
            })
            .state('esterni.new', {
                parent: 'esterni',
                url: '/new',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                	$uibModal.open({
                        templateUrl: 'app/entities/esterni/esterni-dialog.html',
                        controller: 'EsterniDialogController',
                        controllerAs: 'esterniCtrl',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            entity: function () {
                                return {
                                	id: null,
                                	data: null,
                                    codiceFiscale: null,
                                    documentoIdendita: null,
                                    nazionalita: null,
                                    nome: null,
                                    middleName: null,
                                    cognome: null,
                                    denominazione: null,
                                    genere: null,
                                    luogoNascita: null,
                                    emailPrivata: null,
                                    email: null,
                                    uidResponsabile: null,
                                    nominativo: null,
                                    aliasPosta: null,
                                    telefono: null,
                                    telefonoPrivato: null,
                                    fax: null,
                                    faxPrivato: null,
                                    mobile: null,
                                    mobilePrivato: null,
                                    flSmartCard: 0,
                                    flAttivo: 0,
                                    dataNascita: null,
                                    idAb: null,
                                    affiliation: null,
                                    entitlement: null,
                                    titolo: null,
                                    lingua: null,
                                    contattiIm: null,
                                    afferenzaOrg: null,
                                    affDida: null,
                                    affSede: null,
                                    affStudente: null,
                                    cdsStudente: null,
                                    uidUnix: null,
                                    gidUnix: null,
                                    pathShell: null,
                                    idSmartCard: null,
                                    certSmartCard: null,
                                    foto: null,
                                    ambito: null,
                                    categoria: null,
                                    statoSpecifico: null,
                                    cfResponsabile: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                    	$state.go('esterni', null, { reload: true });
                    }, function() {
                        $state.go('esterni');
                    })
                }]
            })
            .state('esterni.edit', {
                parent: 'esterni',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_GESTIONE_ESTERNI'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal','Esterni', function($stateParams, $state, $uibModal,Esterni) {
                	Esterni.get({id : $stateParams.id}, function(result) {
                		if(result.statoSpecifico.id==6){
                			$state.go('esterni');
                         }
                		else{
                			$uibModal.open({
                                templateUrl: 'app/entities/esterni/esterni-dialog.html',
                                controller: 'EsterniDialogController',
                                controllerAs: 'esterniCtrl',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    'entity': ['Esterni', function(Esterni) {
                                        return Esterni.get({id : $stateParams.id}).$promise;
                                    }]
                                }
                            }).result.then(function(result) {
                                $state.go('esterni', null, { reload: true });
                            }, function() {
                                $state.go('^');
                            })
                		}
                    });
                	
                	
                }]
            })
            /*
            .state('esterni.delete', {
	            parent: 'esterni',
	            url: '/{id}/delete',
	            data: {
	                authorities: ['ROLE_GESTIONE_ESTERNI']
	            },
	            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
	                $uibModal.open({
	                    templateUrl: 'app/entities/esterni/esterni-delete-dialog.html',
	                    controller: 'EsterniDeleteController',
	                    controllerAs: 'vm',
	                    size: 'md',
	                    resolve: {
	                        entity: ['Esterni', function(Esterni) {
	                            return Esterni.get({id : $stateParams.id}).$promise;
	                        }]
	                    }
	                }).result.then(function() {
	                    $state.go('esterni', null, { reload: 'esterni' });
	                }, function() {
	                    $state.go('^');
	                });
	            }]
            });
            */
    	}
})();
